<template>
	<v-dialog slot="activator" v-model="dialog" persistent max-width="450px">
		<v-btn slot="activator" icon >
			<v-icon color="grey darken-2">{{this.icon}}</v-icon>
		</v-btn>
		<v-card>
			<v-toolbar>
				<v-toolbar-title>
					DELETE FLOOR
				</v-toolbar-title>
			</v-toolbar>
			<v-card-title class="body-2" color="black">
				<v-layout column class="pl-1 pt-2"> 
				</v-layout>
			</v-card-title>
			<v-card-text class="pb-5">
				<v-form v-if="hasExistingRooms" v-model="valid" ref="form">
					This floor has existing rooms. Cannot delete.
				</v-form>
				<v-form v-if="!hasExistingRooms" v-model="valid" ref="form">
					This will remove the floor from the building.
				</v-form>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="green darken-1" flat @click.native="dialog=false">
					Cancel
				</v-btn>
				<v-btn color="green darken-1" flat @click.native="save" v-if="!hasExistingRooms">
					Delete
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";

export default {
	name: "DeleteFloorDialog",

	data() {
		return {
			valid: false,
			dialog: false,
			floor: null,
			hasExistingRooms: true
		}
	},

	props: [ 'icon' ],

	watch: {
		
		dialog (val) { 
			this.floor = this.dvFloor
		},

		floor (val) {
			if(this.dvBuildingRooms.find((room) => room["floor"] === this.floor["floorNumber"] ) != null )  {
			 	this.hasExistingRooms = true
			 } else {
			 	this.hasExistingRooms = false
			 }

		}

	},

	computed: {
		...mapState({		dvSelectedBuilding: state => state.dv.building,
							dvFloor: state => state.dv.floor,
							dvBuildingRooms: state => state.dv.buildingRooms,
		}),
	},

	methods: {
		...mapMutations([	'setSnackText', 'setdvBuilding', 'setdvFloor'		]),
		...mapActions([		'saveFloor', 'fetchBuilding', 'fetchFloor', 'fetchBuildings', 'deleteFloor'			]),

		save : function() {
			 
			 //TEST
			 if(this.dvBuildingRooms.find((room) => room["floor"] === this.floor["floorNumber"] ) != null )  {
			 	alert("This floor has rooms.")
			 	return
			 }
			// Validate Form 
			if (!this.valid) { this.setSnackText("Form has validation errors");	return;	}

			// Fix default
			if (!this.floor.areaType ) { this.floor.areaType="MAN" }

			// Update floor local memory and database
			this.setdvFloor(this.floor)	
			this.deleteFloor({ floor: this.floor }).then((response) => {
				if (response != "Floor deleted") { 
						this.setSnackText(response)
				}
				else { //Refresh
					// Update the Building Detail showing on the screen
					this.fetchBuilding(this.dvSelectedBuilding.bldgAlpha).then((data) => {				
						this.setdvBuilding(data)				
						//refresh local buildings data
						this.fetchBuildings()
						this.dialog=false		
					})					
				}
			})
		}
	}
}

</script>

<style></style>



// WEBPACK FOOTER //
// src/components/forms/BldgViewer/DeleteFloorDialog.vue